export class QueueStats {
    observer;
    queueName;
    #processing;
    #processed;
    #avgProcessingTime;
    #success;
    #error;
    #rejected;
    constructor(observer, queueName){
        this.observer = observer;
        this.queueName = queueName;
        this.#processing = 0;
        this.#processed = 0;
        this.#avgProcessingTime = 0;
        this.#success = 0;
        this.#error = 0;
        this.#rejected = 0;
        this.observer.on(`queue:${this.queueName}:processing`, ()=>{
            this.#processing++;
        });
        this.observer.on(`queue:${this.queueName}:success`, (wrapped)=>{
            this.#processed++;
            this.#success++;
            this.#processing--;
            this.#calculateAvg(wrapped.data.elapsed);
        });
        this.observer.on(`queue:${this.queueName}:error`, ()=>{
            this.#processed++;
            this.#error++;
            this.#processing--;
        });
        this.observer.on(`queue:${this.queueName}:rejected`, ()=>this.#rejected++);
    }
    #calculateAvg(elapsed) {
        this.#avgProcessingTime = (this.#avgProcessingTime * (this.#success - 1) + elapsed) / this.#success;
    }
    get stats() {
        return {
            processed: this.#processed,
            processing: this.#processing,
            avgProcessingTime: this.#avgProcessingTime,
            success: this.#success,
            error: this.#error,
            rejected: this.#rejected
        };
    }
}
